import { Component, OnInit, ViewChild, Input, AfterViewInit, OnDestroy } from '@angular/core';
import { MatTableDataSource, MatSort, MatTable, MatSnackBar } from '@angular/material';
import { FormControl } from '@angular/forms';
import { Class } from 'app/class';
import { Student } from 'app/students/student';
import { SemsoSnackbarService } from 'app/semso-snackbar.service';
import { ClassService } from '../../class.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BreadcrumbService } from '../../breadcrumb/breadcrumb.service';
import { StudentsService } from 'app/students.service';
import { SemsoEncryptionModule } from 'app/encryption/encryption.module';
import { ShortlistService } from '../shortlist.service';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-all-students',
  templateUrl: './all-students.component.html',
  styleUrls: ['./all-students.component.scss']
})

export class AllStudentsComponent implements OnInit, AfterViewInit, OnDestroy {
  public classes;

  private studentRetrieval$: Subscription;
  private studentsRetrievalError$: Subscription;
  private routeParamsSubscription: Subscription;
  
  public selectedClass = '';
  private searchValue = '';

  public isLoading: Boolean = false;

  private students: Student[];
  public displayedColumns = ['studentnummer', 'studentnaam', 'crebo', 'status', 'favoriet', 'select'];
  public dataSource: MatTableDataSource<Student>;

  $subject: Subject<string> = new Subject<string>();

  @ViewChild(MatSort) sort: MatSort;

  constructor(private studentService: StudentsService,
    private snackbar: SemsoSnackbarService,
    private classService: ClassService,
    private route: ActivatedRoute,
    private encryption: SemsoEncryptionModule,
    public breadcrumbService: BreadcrumbService,
    private shortlistService: ShortlistService,
    private router: Router  ) {
    this.$subject
      .pipe(debounceTime(250))
      .subscribe((event: string) => this.router.navigate([], { queryParams: { search: event }, queryParamsHandling: 'merge' }));
  }

  ngOnInit() {
    this.dataSource = new MatTableDataSource([]);
    this.studentsRetrievalError$ = this.studentService.studentsRetrievalError$.subscribe(data => {
      this.snackbar.error('Studenten kunnen niet worden opgehaald');
    });

    this.classes = this.classService.getAllClasses();
    this.searchValue = '';

    this.routeParamsSubscription = this.route.queryParams.subscribe(data => {
      const item = data['class'];
      const search = data['search'];

      // Clear search
      this.searchValue = search;
      this.dataSource.filter = '';
      this.selectedClass = undefined;

      if (this.searchValue !== null && this.searchValue !== undefined) {
        if (this.searchValue.length > 1) {
          this.searchStudents(this.searchValue);
        } else {
          this.getStudentsForClass('');
        }
      } else {
        if (item !== null || item !== undefined || item.length > 0) {
          this.selectedClass = item;
          this.getStudentsForClass(data['class']);
        }
      }
    });
  }

  shortlist($event, student) {
    $event.stopPropagation();
    if (!student.opShortlist) {
      this.shortlistService.addToShortlist(student.studentnummer, student.creboId)
        .subscribe(data => {
          student.opShortlist = true;
          this.shortlistService.refresh();
        });
    } else {
      this.shortlistService.removeFromShortlist(student.studentnummer, student.creboId)
        .subscribe(data => {
          student.opShortlist = false;
          this.shortlistService.refresh();
        });
    }
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  ngOnDestroy(): void {
    this.studentsRetrievalError$.unsubscribe();
    this.routeParamsSubscription.unsubscribe();
  }

  private getStudentsForClass(klas: string) {
    this.isLoading = false;
    this.studentService.getAllStudentsByClass(klas).subscribe(data => {
      this.isLoading = false;
      data.forEach(d => {
        d.studentnummerEncrypted = this.encryption.encrypt(d.studentnummer);
      });
      this.dataSource.data = data;
    }, error => this.isLoading = false);
  }

  private searchStudents(search: string) {    
    if (search != '') {      
      this.isLoading = true;
      this.classService
        .searchAllStudents(search)
        .subscribe(data => {
          this.isLoading = false;
          data.forEach(d => {
            d.studentnummerEncrypted = this.encryption.encrypt(d.studentnummer);
          });
          this.dataSource.data = data;          
        }, error => this.isLoading = false);
    }
  }

  applyFilter(filterValue: string) {
    // Search student if no class selected
    if (this.selectedClass == undefined) {
      this.$subject.next(filterValue);              
    } else {
      filterValue = filterValue.trim();
      filterValue = filterValue.toLowerCase();
      this.dataSource.filter = filterValue;
    }
  }

  private unselectRows() {
    this.dataSource.data.forEach(row => {
      row.active = false;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/students/all-students/all-students.component.ts